"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalDeleteMessage = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ConditionalDeleteMessage = exports.ConditionalDeleteMessage = function ConditionalDeleteMessage(_ref) {
  var assetName = _ref.assetName,
    assetVersion = _ref.assetVersion,
    onDeleteTypeChange = _ref.onDeleteTypeChange,
    isLastVersion = _ref.isLastVersion;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hardDeletionEnabled = _useState2[0],
    setHardDeletionEnabled = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isInitializing = _useState4[0],
    setIsInitializing = _useState4[1];
  var fetch = (0, _exchangeReactHooks.useFetch)();
  var profile = (0, _exchangeReactHooks.useProfile)();
  var rootOrganizationId = profile.organizationId;
  _react.default.useEffect(function () {
    var initializeHardDeletionEnabledForOrg = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
        var response, settings;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return fetch("/api/v2/organizations/".concat(rootOrganizationId, "/settings?settings=deletionSettings"), {
                method: 'GET'
              });
            case 1:
              response = _context.sent;
              _context.next = 2;
              return response.json();
            case 2:
              settings = _context.sent;
              setHardDeletionEnabled(settings.deletionSettings.hardDeletionEnabled);
              setIsInitializing(false);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function initializeHardDeletionEnabledForOrg() {
        return _ref2.apply(this, arguments);
      };
    }();
    initializeHardDeletionEnabledForOrg();
  }, [rootOrganizationId, fetch]);
  var handleCheckboxCLicked = (0, _react.useCallback)(function (event) {
    return onDeleteTypeChange(event.value ? 'hard' : 'soft');
  }, [onDeleteTypeChange]);
  var hardOrSoftDeleteMessage = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLastVersion ? /*#__PURE__*/_react.default.createElement("p", {
    "data-test-id": "hard-or-soft-delete-last-version-message"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Warning:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "This is the last version."), /*#__PURE__*/_react.default.createElement("li", null, "Deleting this will remove the asset, its details page, and metadata from the catalog."))))) : null, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    testId: "hard-or-soft-delete-checkbox",
    label: "Allow the GAV (group ID, asset ID, and version) to be reusable.",
    onChange: handleCheckboxCLicked
  }));
  var softDeleteMessage = isLastVersion ? /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "soft-delete-last-version-message"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Warning:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "This is the last version."), /*#__PURE__*/_react.default.createElement("li", null, "Deleting this will remove the asset, its details page, and metadata from the catalog."), /*#__PURE__*/_react.default.createElement("li", null, "The GAV (group ID, asset ID, and version) will not be reusable."))))) : /*#__PURE__*/_react.default.createElement("p", {
    "data-test-id": "soft-delete-versions-remain-message"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Warning:", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "The GAV (group ID, asset ID, and version) will not be reusable.")))));
  var message = hardDeletionEnabled ? /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "hard-or-soft-delete-message"
  }, hardOrSoftDeleteMessage) : /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "soft-delete-message"
  }, softDeleteMessage);
  return !isInitializing ? /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "conditional-delete-message"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to delete", ' ', /*#__PURE__*/_react.default.createElement("strong", null, assetName, " ", assetVersion), "?"), message) : null;
};
//# sourceMappingURL=ConditionalDeleteMessage.js.map